var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSapSapBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 42,
    viewBox: "0 0 88 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 42H44.4745L88 0H0V42Z",
    fill: "url(#paint0_linear_1298_5149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2214 8.40062H43.5302L43.5588 28.1218L35.991 8.39369H28.4878L22.0339 24.8699C21.3479 20.677 16.8541 19.231 13.3212 18.147C10.9858 17.4229 8.50943 16.3596 8.54051 15.1834C8.55963 14.2171 9.86715 13.3222 12.4607 13.456C14.2032 13.5483 15.7402 13.6866 18.8022 15.1096L21.8092 10.0496C19.0197 8.67966 15.1617 7.81481 12.0089 7.8125H11.9897C8.29907 7.8125 5.22749 8.96564 3.32479 10.8637C2.0066 12.1692 1.26384 13.9166 1.25239 15.7392C1.20459 18.3038 2.17744 20.1212 4.22595 21.5742C5.95416 22.7988 8.16761 23.5922 10.1157 24.1734C12.5204 24.8929 14.4853 25.5179 14.4614 26.8487C14.4433 27.3367 14.24 27.8013 13.8901 28.154C13.2901 28.7514 12.3698 28.975 11.0981 28.9981C8.64328 29.0488 6.82663 28.6776 3.92716 27.024L1.25 32.1485C4.12679 33.7433 7.39329 34.5666 10.7109 34.5332H11.4973C14.5378 34.4802 16.9951 33.7768 18.9623 32.2546C19.0747 32.1693 19.1751 32.0816 19.2802 31.9917L18.9528 33.6269L26.2839 33.6061L27.601 30.3542C29.0921 30.8332 30.6547 31.0724 32.2263 31.0623C33.7586 31.0712 35.2826 30.8454 36.7416 30.3934L37.6571 33.6061H50.8039L50.8374 26.196H53.6365C60.4035 26.196 64.393 22.8749 64.393 17.3006C64.393 11.0966 60.5015 8.39369 52.2262 8.39369L52.2214 8.40062ZM32.2024 25.2596C31.2561 25.2677 30.3161 25.1115 29.4272 24.7984L32.1713 16.438H32.2239L34.9226 24.8214C34.0487 25.118 33.1288 25.2685 32.2024 25.2665V25.2596ZM52.7305 20.4579H50.8183V13.7212H52.7305C55.2738 13.7212 57.3056 14.5377 57.3056 17.0446C57.3056 19.6392 55.2738 20.4579 52.7305 20.4579Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1298_5149",
    x1: 43.994,
    y1: -0.0046126,
    x2: 43.994,
    y2: 42.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#1D96D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#157CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#106DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1067B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapSapBlue);
export default __webpack_public_path__ + "static/media/Sap_SapBlue.54eeca5971cb6e41df7a3db6777d1f4b.svg";
export { ForwardRef as ReactComponent };